import React, { createContext, useContext, useEffect, useState } from "react";

const CenturionContext = createContext({ unlocked: false, unlock: () => {}, lock: () => {} });

const KEYWORD = "centurion";
const STORAGE_KEY = "wxza_centurion_unlocked";

export const CenturionProvider = ({ children }) => {
  const [unlocked, setUnlocked] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch { return false; }
  });
  const [buffer, setBuffer] = useState("");

  useEffect(() => {
    if (unlocked) return;
    const onKey = (e) => {
      // Ignore typing in inputs/textareas
      const tag = (e.target?.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea" || e.target?.isContentEditable) return;
      if (e.key.length !== 1) return;
      const next = (buffer + e.key.toLowerCase()).slice(-KEYWORD.length);
      setBuffer(next);
      if (next === KEYWORD) {
        setUnlocked(true);
        try { localStorage.setItem(STORAGE_KEY, "1"); } catch {}
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [buffer, unlocked]);

  const unlock = () => {
    setUnlocked(true);
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch {}
  };
  const lock = () => {
    setUnlocked(false);
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
  };

  return (
    <CenturionContext.Provider value={{ unlocked, unlock, lock }}>
      {children}
    </CenturionContext.Provider>
  );
};

export const useCenturion = () => useContext(CenturionContext);
